import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InternalService {
  public bookingInProcess = new BehaviorSubject<boolean>(false);
  public forceReleasePage = new BehaviorSubject<boolean>(false);

  private readonly _hideHeader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private readonly _hideFooter$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {

    // this.titleService.setTitle(''); // TODO specific title
  }

  public readonly hideFooter$ = this._hideFooter$.asObservable();
  public readonly hideHeader$ = this._hideHeader$.asObservable();

  setBookingInProcess(value): void {
    this.bookingInProcess.next(value);
  }

  setForceReleasePage(value): void {
    this.forceReleasePage.next(value);
  }

  setHideHeader(value: boolean): void {
    this._hideHeader$.next(!!value);
  }

  setHideFooter(value: boolean): void {
    this._hideFooter$.next(!!value);
  }
}
